// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---node-modules-gatsby-theme-style-guide-src-template-js": function componentNodeModulesGatsbyThemeStyleGuideSrcTemplateJs() {
    return import("./../gatsby-theme-style-guide/src/template.js"
    /* webpackChunkName: "component---node-modules-gatsby-theme-style-guide-src-template-js" */
    );
  },
  "component---src-components-layouts-post-js": function componentSrcComponentsLayoutsPostJs() {
    return import("./../../src/components/layouts/post.js"
    /* webpackChunkName: "component---src-components-layouts-post-js" */
    );
  },
  "component---src-pages-index-mdx": function componentSrcPagesIndexMdx() {
    return import("./../../src/pages/index.mdx"
    /* webpackChunkName: "component---src-pages-index-mdx" */
    );
  },
  "component---src-pages-key-mdx": function componentSrcPagesKeyMdx() {
    return import("./../../src/pages/key.mdx"
    /* webpackChunkName: "component---src-pages-key-mdx" */
    );
  },
  "component---src-pages-test-mdx": function componentSrcPagesTestMdx() {
    return import("./../../src/pages/test.mdx"
    /* webpackChunkName: "component---src-pages-test-mdx" */
    );
  }
};